import type { RootState } from '@/store';

export const errorSelector = (state: RootState) => state.dashboard.error;
export const dbQueryStateSelector = (state: RootState) => state.dashboard.queryState;
export const iaDataSelector = (state: RootState) => state.dashboard.iaData;
export const paDataSelector = (state: RootState) => state.dashboard.paData;
export const allIADataSelector = (state: RootState) => state.dashboard.allIAData;
export const selectedIdxSelector = (state: RootState) => state.dashboard.selectedIdx;
export const initialSetupSelector = (state: RootState) => state.dashboard.initialSetup;
